import React from 'react';

const RightWrapper = ({ children, custom, className, ...rest }) => {
    return (
        <div className={`${!custom && 'col-12 col-md-6 px-2 pe-md-0'} ${className || ''}`} {...rest}>
            {children}
        </div>
    );
};

export default RightWrapper;
